import React, { act, useContext, useEffect, useState } from "react";
import { CustomerInfoBlock, UsersBlock } from "../account-details/blocks";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { FarmInfoBlock } from "./blocks";
import ModalFarmOrSubEnt from "./modals/modal-farm-or-sub-ent";
import { CustomButton } from "../../components";
import ModalFarmRemove from "./modals/modal-farm-remove";
import ModalUser from "../account-details/modals/modal-user";
import useFarm from "../../hooks/use-farm";
import { LoginContext } from "../../context/login-context";

const FarmDetails = () => {
  const navigate = useNavigate()
  const { state: userData } = useContext(LoginContext);
  const { farmName: farmNameParam } = useParams();
  //todo this is broken if user has multiple farms will need to fix in login-user on server
  // const defaultFarmName = userData?.associatedAcctIds?.temp_farm_name
  const [farmName, setFarmName] = useState(farmNameParam || userData?.associatedAcctIds?.temp_farm_name);
  const { farm, refetchFarm } = useFarm({ farmName });

  const [showFarmModal, setShowFarmModal] = useState(false);
  const [showFarmRemoveModal, setShowFarmRemoveModal] = useState(false);
  const [showUserModal, setShowUserModal] = useState(false);
  const [showUserRemoveModal, setShowUserRemoveModal] = useState(false);

  const [activeUser, setActiveUser] = useState(null);

  useEffect(() => {
      if(!farmNameParam) {
        return
      }
      setFarmName(farmNameParam)
	}, [farmNameParam]);

    useEffect(() => {
      refetchFarm()
  }, [farmName]);



  const handleEditFarmDetails = (farm) => {
    setShowFarmModal(true);
  };

  const handleRemoveFarm = (id) => {
    setShowFarmRemoveModal(true);
  };

  const farmModalClose = () => {
    setShowFarmModal(false);
    refetchFarm()
    setShowFarmRemoveModal(false);
  };


  const handleAddEditUser = (user) => {
    setShowUserModal(true);
    setActiveUser(user);
  };

  const userModalClose = () => {
    setShowUserModal(false);
    refetchFarm()
    setShowUserRemoveModal(false);
  }

  const handleRemoveUser = (id) => {
    setShowUserRemoveModal(true);
  };

  const btnRemove = (
    <CustomButton
      label="Remove farm"
      color="danger"
      onClick={(activeFarm) => handleRemoveFarm(activeFarm)}
      outlined
    />
  );

  const farmInfo = (
    <FarmInfoBlock
      farm={farm}
      onClick={handleEditFarmDetails}
      btnRemove={btnRemove}
      canCrud={userData?.isValmontUser}
    />
  );

  const tableUsers =  (
    <UsersBlock
    canCrud={
      userData?.isValmontUser || 
      userData?.associatedAcctIds.farmAcctIds.includes(farm?.id)
     } 
    userConfigType={"Farm"}
    users={farm?.users}
      onAddEditUser={handleAddEditUser}
      onRemoveUser={handleRemoveUser}
    />
  );

  const modals = (
    <>
          {showUserModal && (
        <ModalUser
        userConfigType={"Farm"}
          open={showUserModal}
          onClose={userModalClose}
          user={activeUser||{user_role:"FARM"}}
          account= {farm}
        />
      )}

      {showFarmModal && (
        <ModalFarmOrSubEnt
          open={showFarmModal}
          onClose={farmModalClose}
          account={farm}
          // activeFarm={farmData}
        />
      )}

      {showFarmRemoveModal && (
        <ModalFarmRemove
          open={showFarmRemoveModal}
          onClose={farmModalClose}
          account={farm}
        />
      )}
    </>
  );

  return (
    <>
      {/* {acctInfo} */}
      {farmInfo}
      {tableUsers}
      {modals}
    </>
  );
};

export default FarmDetails;
